import { Link } from "react-router-dom";
import { CheckCircle, Storefront, Buildings, User, GraduationCap, ForkKnife, ArrowRight } from "@phosphor-icons/react";
import { PageHero, CTASection } from "../components/Sections";
import { Reveal, Overline } from "../components/Reveal";
import { FORMAZIONE, IMAGES } from "../data/content";

const icons = [Storefront, Buildings, User, GraduationCap, ForkKnife];

export default function Formazione() {
  return (
    <div data-testid="formazione-page">
      <PageHero
        overline="Formazione"
        title="Formazione che diventa risultato: metodo, tecnica e mentalità."
        subtitle="Percorsi su misura per locali, aziende, privati e professionisti. Trasferisco standard concreti e immediatamente applicabili."
        image={IMAGES.cocktail}
      />

      <section className="pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {FORMAZIONE.map((f, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={f.title} delay={i * 0.08}>
                <div data-testid={`formazione-card-${i}`} className="bg-[#111113] border border-white/5 rounded-sm p-8 lg:p-10 h-full hover:border-[#D97736]/30 transition-all group">
                  <div className="w-14 h-14 rounded-sm bg-[#D97736]/10 flex items-center justify-center text-[#D97736] group-hover:bg-[#D97736] group-hover:text-white transition-colors">
                    <Icon size={28} />
                  </div>
                  <h2 className="mt-6 font-display text-2xl font-semibold">{f.title}</h2>
                  <p className="mt-4 text-[#A1A1AA] leading-relaxed">{f.description}</p>
                  <ul className="mt-6 space-y-2">
                    {f.points.map((p) => (
                      <li key={p} className="flex items-center gap-3 text-sm text-[#F8F8F8]">
                        <CheckCircle size={18} weight="fill" className="text-[#D97736] shrink-0" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Reveal className="text-center max-w-3xl mx-auto">
            <Overline>Come lavoro</Overline>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold">Un percorso in 3 fasi</h2>
          </Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { n: "01", t: "Analisi", d: "Capisco livello di partenza, obiettivi e contesto: staff, locale o target del corso." },
              { n: "02", t: "Formazione", d: "Sessioni pratiche e teoriche, con materiali e standard applicabili da subito." },
              { n: "03", t: "Follow-up", d: "Verifica dei risultati e supporto continuo per consolidare ciò che è stato appreso." },
            ].map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1}>
                <div className="bg-[#111113] border border-white/5 rounded-sm p-8 h-full">
                  <span className="font-display text-4xl font-bold text-[#D97736]/40">{s.n}</span>
                  <h3 className="mt-4 font-display text-2xl font-semibold">{s.t}</h3>
                  <p className="mt-3 text-[#A1A1AA] leading-relaxed">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-12 text-center">
            <Link to="/contatti" data-testid="formazione-cta" className="inline-flex items-center gap-2 bg-[#D97736] text-white px-8 py-4 rounded-sm font-semibold hover:bg-[#B85B22] transition-all">
              Richiedi un percorso su misura <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
